import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { CompaniesSummaryRecord } from 'src/models';
import { fetchCompaniesSummaryAction } from 'src/services/companiesSummary';

const companiesSummaryAdapter = createEntityAdapter({
  selectId: (item: CompaniesSummaryRecord) => item.id,
});

export const companiesSummarySelectors = companiesSummaryAdapter.getSelectors();

const initialState: {
  isPending: boolean | null;
  hasError: boolean;
} = {
  isPending: null,
  hasError: false,
};

const companiesSummarySlice = createSlice({
  name: 'companiesSummary',
  initialState: companiesSummaryAdapter.getInitialState(initialState),
  reducers: {
    clearCompanySummaryState: (state) => {
      state.isPending = null;
      state.hasError = false;
      companiesSummaryAdapter.setAll(state, []);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCompaniesSummaryAction.pending, (state) => {
      state.isPending = true;
      state.hasError = false;
    });
    builder.addCase(
      fetchCompaniesSummaryAction.fulfilled,
      (state, { payload }) => {
        companiesSummaryAdapter.setAll(state, payload);
        state.isPending = false;
      },
    );
    builder.addCase(fetchCompaniesSummaryAction.rejected, (state) => {
      state.hasError = true;
      state.isPending = false;
    });
  },
});

export const { clearCompanySummaryState } = companiesSummarySlice.actions;

const { reducer } = companiesSummarySlice;

export default reducer;
